/** Tiny JSON API helper - GET when no body, POST otherwise.
 *  Also the ONE place that (a) translates the server's Spanish error texts for
 *  English players and (b) notices a dead session (token revoked: logged out
 *  elsewhere, password changed, account banned) and signs this device out
 *  instead of leaving a half-logged-in UI whose saves silently fail. */
import { API_TOKEN } from '../state';
import { LANG } from '../ui/i18n';
import { API_BASE } from './base';

const ERR_EN: Record<string, string> = {
  'Credenciales incorrectas': 'Wrong email or password',
  'Email ya registrado': 'That email is already registered',
  'Cuenta suspendida. Contacta soporte.': 'Account suspended. Contact support.',
  'Contraseña: 6+ caracteres': 'Password: 6+ characters',
  'Contraseña demasiado larga': 'Password too long',
  'La contraseña no puede ser tu email': 'The password cannot be your email',
  'La nueva contraseña debe ser distinta': 'The new password must be different',
  'Contraseña actual incorrecta': 'Current password is wrong',
  'Datos inválidos': 'Invalid data',
  'Fecha de nacimiento requerida': 'Date of birth is required',
  'Fecha de nacimiento inválida': 'Invalid date of birth',
  'Debes tener 13 años o más': 'You must be 13 or older',
  'Demasiadas solicitudes. Espera un momento.': 'Too many requests. Wait a moment.',
  'Demasiados intentos. Espera unos minutos.': 'Too many attempts. Wait a few minutes.',
  'Sesión inválida': 'Your session expired — sign in again',
  'Código inválido o vencido': 'Invalid or expired code',
  'Error de servidor': 'Server error',
  'Error creando cuenta': 'Could not create the account',
  'Error iniciando sesión': 'Could not sign in',
  'Solo el fundador': 'Founder only',
  'Nada que guardar': 'Nothing to save',
};
export const errText = (msg: string): string => (LANG === 'en' && ERR_EN[msg]) ? ERR_EN[msg] : msg;

let expiring = false;
/** The server no longer accepts this device's token → clear the local session
 *  and reload to the door. Guest data (wallet/stats) stays: nothing is lost. */
export function sessionExpired(reason: string): void {
  if (expiring) return;
  expiring = true;
  try {
    localStorage.removeItem('mdtoken');
    localStorage.removeItem('account');
    sessionStorage.setItem('mdexpired', reason);
  } catch { /* */ }
  setTimeout(() => location.reload(), 50);
}

export async function api(path: string, body?: unknown): Promise<any> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    const sentToken = !!API_TOKEN;
    if (API_TOKEN) headers.Authorization = 'Bearer ' + API_TOKEN;
    const r = await fetch(API_BASE + path, {
          method: body === undefined ? 'GET' : 'POST',
          headers,
          body: body === undefined ? undefined : JSON.stringify(body),
    });
    let j: any = null;
    try { j = await r.json(); } catch (e) { /* non-JSON response */ }
    if (!r.ok || (j && j.error)) {
      const msg = (j && j.error) || 'HTTP ' + r.status;
      // dead session: only when WE sent a token and the server rejected the token
      // itself (401 'Sesión inválida') or the account (403 suspended). A wrong
      // current password on /api/password is also 401 but carries its own text.
      if (sentToken && ((r.status === 401 && msg === 'Sesión inválida') || (r.status === 403 && /suspendida/.test(msg)))) {
        sessionExpired(msg);
      }
      throw new Error(errText(msg));
    }
    return j;
}
